import {send} from '@/composables/apiClient'

// Shared report download. The server returns a gzip CSV (Content-Encoding: gzip,
// so the browser decompresses transparently and response.data is the CSV text)
// or a base64-encoded PDF. One handler so every report downloads the same way.
export function useReportExport() {
    const handleDownloadResponse = (response, fileName) => {
        if (!response?.data) {
            console.error('Server returned no data for export.')
            return
        }

        let url
        if (fileName.includes('csv')) {
            url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv'}))
        } else {
            const byteCharacters = atob(response.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            url = window.URL.createObjectURL(new Blob([new Uint8Array(byteNumbers)], {type: 'application/pdf'}))
        }

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        // Defer revoke: revoking synchronously right after click can abort the
        // download for larger blobs in some browsers.
        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    }

    // Convenience for the GET-based fleet reports: adds the download flags and
    // streams the result down. Throws on failure so the caller can flash an error.
    // responseType:'text' so axios never tries to JSON-parse the CSV/base64 body
    // (the body arriving intact was previously an accident of the parse failing).
    const downloadReport = async (endpoint, params, type, fileName) => {
        const response = await send('get', endpoint, {...params, download: true, type}, {responseType: 'text'})
        handleDownloadResponse(response, fileName)
    }

    return {handleDownloadResponse, downloadReport}
}
